module.exports = __webpack_public_path__ + "assets/img/instagram-black.6827d42f.svg";